import React from "react"
import { Link } from "gatsby"
import { HeadingTwo, Paragraph } from "../elements"
import {
  linkHoveredAccent,
  textColorDark,
  linkAccent,
  fontPrimary,
  lightMetaAccent,
} from "../variables"
import styled from "styled-components"
import { formatDate } from "../helpers"
import { slugify } from "../utils"

const PostTextSnippet = ({ post, isFeatured }) => {
  const { title, release_date, description, source } = post.data
  const { tags } = post

  return (
    <SnippetContainer isFeatured={isFeatured}>
      <PostHeader
        fontSize={isFeatured ? "32px" : "22px"}
        fontWeight="700"
        letterSpacing="0"
      >
        <Link to={`/news-and-updates/${slugify(title.text)}`}>
          {title.text}
        </Link>
      </PostHeader>
      <div className="post-info">
        <span className="post-meta">
          {formatDate(release_date)} | {source.text}
        </span>
        <div className="tags">
          {tags.map(tag => (
            <Link to={`/tags/${tag}`} key={tag}>
              <Paragraph
                lineHeight="1.5"
                fontSize={isFeatured ? "15px" : "13px"}
                fontWeight="700"
                color={linkAccent}
              >
                {tag} &nbsp;
              </Paragraph>
            </Link>
          ))}
        </div>
      </div>
      <div
        className="post-description"
        dangerouslySetInnerHTML={{ __html: description.html }}
      ></div>
    </SnippetContainer>
  )
}

export default PostTextSnippet

const PostHeader = styled(HeadingTwo)`
  font-family: ${fontPrimary};
`

const SnippetContainer = styled.div`
  width: 100%;

  ${HeadingTwo} {
    a {
      color: ${textColorDark};

      &:hover {
        color: ${linkHoveredAccent};
      }
    }
  }

  .post-info {
    display: flex;
    align-items: center;
    margin: 8px 0 15px 0;

    .post-meta {
      color: ${lightMetaAccent};
    }

    span {
      font-size: ${({ isFeatured }) => (isFeatured ? "15px" : "13px")};
    }

    .tags {
      margin-left: 18px;
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
    }
  }

  .post-description {
    line-height: 1.6;
    font-size: ${({ isFeatured }) => (isFeatured ? "20px" : "15px")};

    p {
      margin: 0;
    }
  }
`
